<template>
	<section :class="[componentClass, colorMode, {visible: visible, ready: ready}]">
		<PersonWrapper :number="1" />
		<PersonWrapper :number="2" :class="['bg-green']" />
		<PersonWrapper :number="3" :class="['bg-yellow']" />
		<PersonWrapper :number="4" :class="['bg-green']" />
		<PersonWrapper :number="5" />
		<PersonWrapper :number="6" :class="['bg-yellow']" />
		<PersonWrapper :number="7" :class="['bg-yellow']" />
		<div class="zoom-title zoom-grid-item">
			<div class="text-wrapper">
				<h1>
					{{ data.year }}
				</h1>
				<h2 v-if="line_1!=='' && line_2!==''">
					{{ line_1 }}<br />
					{{ line_2 }}
				</h2>
				<h2 v-if="line_1!=='' && line_2===''">
					{{ line_1 }}
				</h2>
			</div>
		</div>
		<PersonWrapper :number="8" :class="['bg-green']" />
		<PersonWrapper :number="9" :class="['bg-green']" />
		<PersonWrapper :number="10" :class="['bg-yellow']" />
		<PersonWrapper :number="11" />
		<PersonWrapper :number="12" :class="['bg-yellow']" />
		<PersonWrapper :number="13" :class="['bg-green']" />
		<PersonWrapper :number="14" :class="['bg-yellow']" />
	</section>
</template>

<script>
import BaseBlock from 'RuterSharedBlocks/Base'
import PersonWrapper from './zoom-hero/PersonWrapper'
export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'zoom-hero',
			line_1: '',
			line_2: '',
		}
	},
	mounted() {
		if (typeof this.data.text !== 'undefined') {
			const parts = this.data.text.split(', ');
			if (parts.length===2) {
				this.line_1 = parts[0];
				this.line_2 = parts[1];
			} 
		}
	},
	components: {
		PersonWrapper
	}
}
</script>

<style lang="scss">
@import "@/styles/scss/component/_zoom-hero";
</style>